import { compose, getContext } from 'recompose';
import PropTypes from 'prop-types';
import { AccountClosed as AccountClosedComponent } from './AccountClosed';
import { withMyAccountTranslate } from '../../hoc';

var enhance = compose(getContext({ langCode: PropTypes.string }), withMyAccountTranslate);

export var AccountClosed = enhance(AccountClosedComponent);